import type { ArticleBlock, ArticleDocument, ArticleInlineNode, ArticleTextMark } from "../../../website/src/domain/models";

export type { ArticleBlock, ArticleDocument, ArticleInlineNode, ArticleTextMark };

export type Admin = {
  id: string;
  username: string;
  csrfToken: string;
};

export type Category = { id: string; title: string };
export type ContentType = "ARTICLE" | "LEGAL";
export type SiteId = "velnpay" | "velnsteam" | "velnup";
export const siteNames: Record<SiteId, string> = { velnpay: "VelnPay", velnsteam: "VelnSteam", velnup: "VelnUp" };
export const siteOrigins: Record<SiteId, string> = { velnpay: "https://velnpay.ru", velnsteam: "https://steam.velnpay.ru", velnup: "https://up.velnpay.ru" };

export type ArticleCover = { mediaId: string; alt: string };

export type ArticleMedia = {
  id: string;
  kind: "image" | "video";
  src: string;
  mimeType: "image/png" | "image/jpeg" | "image/webp" | "image/gif" | "video/mp4" | "video/webm";
  width: number;
  height: number;
  byteSize?: number;
  durationSeconds?: number;
};

export type MediaAsset = Omit<ArticleMedia, "byteSize"> & {
  byteSize: number;
  sha256: string;
  originalName: string;
  articleId: string | null;
  createdAt: string;
};

export type ArticleListItem = {
  siteId: SiteId;
  id: string;
  title: string;
  slug: string;
  categoryId: string;
  status: "DRAFT" | "PUBLISHED" | "ARCHIVED";
  updatedAt: string;
  publishedAt: string | null;
  version: number;
  hasUnpublishedChanges: boolean;
  contentType: ContentType;
};

export type ArticleDetail = ArticleListItem & {
  excerpt: string;
  seoTitle: string;
  seoDescription: string;
  cover: ArticleCover | null;
  media: ArticleMedia[];
  content: ArticleDocument;
  createdAt: string;
  revisionNumber: number;
  revisionId: string;
  legalReviewConfirmed: boolean;
};

export type ArticlePayload = {
  siteId: SiteId;
  title: string;
  slug: string;
  excerpt: string;
  categoryId: string;
  seoTitle: string;
  seoDescription: string;
  cover: ArticleCover | null;
  content: ArticleDocument;
  contentType: ContentType;
  legalReviewConfirmed: boolean;
  version?: number;
};

export type PublicationJob = {
  id: string;
  articleId: string | null;
  revisionId: string;
  status: "QUEUED" | "BUILDING" | "DEPLOYING" | "SUCCEEDED" | "FAILED";
  snapshotSha256: string;
  runnerJobId: string | null;
  publicUrl: string | null;
  error: string | null;
  createdAt: string;
  updatedAt: string;
  completedAt: string | null;
};

